export const threeOptionProducts = [
  "/products/classic-bed",
  "/products/essential-bed",
];

// TODO: update the paths with the renaming of the products
export const twoOptionProducts = [
  "/products/the-dresser",
  "/products/nest-dresser",
  "/products/the-credenza",
  "/products/nest-credenza",
  "/products/the-bookshelf",
  "/products/pillar-bookshelf",
  "/products/the-shelving",
  "/products/nest-shelving",
  "/products/the-dresser-add-ons",
  "/products/nest-dresser-add-ons",
  "/products/the-cubby",
  "/products/nest-shelf",
];

const allPaths = [...threeOptionProducts, ...twoOptionProducts];

export default allPaths;
